import { CSSProperties } from 'react';

import classes from './ToolbarSelect.module.scss';

type ToolbarSelectStylesProps = {
  maxWidth?: number;
  direction?: 'ltr' | 'rtl';
};

export const useToolbarSelectStyles = (props: ToolbarSelectStylesProps = {}) => {
  const { maxWidth = 95, direction = 'ltr' } = props;

  const style = {
    '--toolbar-select-max-width': `${maxWidth}px`,
    '--toolbar-select-min-width': `${maxWidth * 2}px`
  } as CSSProperties;

  const selectItemClassName =
    direction === 'rtl' ? `${classes.selectItem} ${classes.selectItemRtl}` : classes.selectItem;

  return {
    classes: {
      selectRoot: classes.selectRoot,
      selectItem: selectItemClassName,
      selectRightSection: classes.selectRightSection,
      selectIcon: classes.selectIcon,
      selectDropdown: classes.selectDropdown,
      selectInput: classes.selectInput,
      selectInputHidden: classes.selectInputHidden,
      selectLabel: classes.selectLabel,
      selectLabelEnd: classes.selectLabelEnd
    },
    style
  };
};
